import ArrowCircleDownIcon from '~icons/material-symbols-light/arrow-circle-down-outline';
import ArrowCircleUpIcon from '~icons/material-symbols-light/arrow-circle-up-outline';
import CheckIcon from '~icons/material-symbols-light/check';
import CheckCircleIcon from '~icons/material-symbols-light/check-circle-outline';
import LockIcon from '~icons/material-symbols-light/lock-outline';
import NorthEastIcon from '~icons/material-symbols-light/north-east';
import VillaIcon from '~icons/material-symbols-light/villa-outline';

export default {
	pt: {
		hero: {
			title: 'Off-Market Pilar',
			description: 'Uma nova forma de buscar e vender com total discrição.'
		},
		breadcrumb: {
			home: 'Início',
			offMarket: 'Off-Market Pilar'
		},
		whatAreOffMarketProperties: {
			card: {
				title: 'O que são imóveis Off-Market?',
				content:
					'São propriedades de alto padrão não listadas publicamente, oferecidas apenas a clientes selecionados, garantindo total discrição no processo de compra.'
			}
		},
		whoCanBenefitWithOffMarketProperties: {
			title: 'Quem pode se beneficiar dos imóveis Off-Market?',
			itemsIcon: CheckIcon,
			items: [
				'Investidores que valorizam a discrição',
				'Compradores que buscam exclusividade',
				'Vendedores que desejam privacidade',
				'Clientes que desejam evitar concorrência e lances'
			]
		},
		benefits: [
			{
				icon: LockIcon,
				title: 'Privacidade total',
				description: 'Todos os detalhes do imóvel mantidos em sigilo absoluto.'
			},
			{
				icon: CheckCircleIcon,
				title: 'Sem concorrência ou lances',
				description:
					'Negociações privadas, sem disputas com outros compradores.'
			},
			{
				icon: VillaIcon,
				title: 'Imóveis exclusivos',
				description: 'Acesso à imóveis listados apenas no PilarHomes.'
			}
		],
		buy: {
			icon: ArrowCircleDownIcon,
			title: 'Compra de imóveis Off-Market',
			lastStepIcon: CheckIcon,
			steps: [
				{
					title: 'Contato com especialistas',
					description:
						'Fale com apenas um corretor e descubra opções exclusivas Off-Market.'
				},
				{
					title: 'Seleção personalizada',
					description: 'Apresentamos imóveis exclusivos baseados no seu perfil.'
				},
				{
					title: 'Negociação confidencial',
					description:
						'Negocie diretamente com o proprietário de forma sigilosa.'
				},
				{
					title: 'Concretização do negócio',
					description: 'Concluímos a compra com segurança e discrição.'
				}
			]
		},
		sell: {
			icon: ArrowCircleUpIcon,
			title: 'Venda de imóveis Off-Market',
			lastStepIcon: CheckIcon,
			steps: [
				{
					title: 'Contato com especialistas',
					description:
						'Conecte-se com um corretor especializado para uma venda segura e privada.'
				},
				{
					title: 'Avaliação e divulgação privada',
					description:
						'Seu imóvel é avaliado e apresentado a compradores exclusivos, sem exposição.'
				},
				{
					title: 'Negociação confidencial',
					description: 'Negocie diretamente com compradores de forma sigilosa.'
				},
				{
					title: 'Concretização do negócio',
					description: 'A venda é finalizada com total sigilo e segurança.'
				}
			]
		},
		questionsTitle: 'Perguntas frequentes',
		questions: [
			{
				question: 'O que são imóveis Off-Market?',
				answer:
					'Imóveis Off-Market são propriedades de alto padrão, fora dos canais de venda públicos. Exclusivos, raros e de características únicas, esses imóveis estão disponíveis apenas para um grupo restrito de compradores. Esse modelo oferece uma negociação mais reservada, preservando tanto a natureza exclusiva do imóvel, quanto a privacidade de todos os envolvidos.'
			},
			{
				question:
					'Quais as vantagens de comprar e vender imóveis no modelo Off-Market?',
				answer:
					'Comprar e vender imóveis Off-Market oferece diversas vantagens para ambas as partes envolvidas. A principal delas é a privacidade total, pois todos os detalhes do imóvel são mantidos em sigilo absoluto, garantindo discrição tanto para o comprador quanto para o vendedor. Com isso, o comprador tem acesso a imóveis exclusivos e raros, já que, no modelo Off-Market, as propriedades não são divulgadas publicamente, oferecendo oportunidades únicas. As negociações acontecem de forma discreta, diretamente entre comprador e vendedor, o que não só elimina a concorrência ou lances de outros interessados, mas também assegura que o imóvel seja mostrado apenas para compradores qualificados. Em resumo, o modelo Off-Market proporciona um processo mais reservado, vantajoso e seguro, preservando tanto a natureza exclusiva do imóvel quanto o valor da propriedade e a privacidade de todos os envolvidos.'
			},
			{
				question: 'Qual é o processo de venda de um imóvel Off-Market?',
				answer:
					'Para vender seu imóvel no modelo Off-Market no PilarHomes, o primeiro passo é clicar em "Falar com especialistas" e preencher o formulário com os detalhes do seu imóvel. Com os dados fornecidos, a equipe do PilarHomes irá conectá-lo a um corretor de excelência da Rede Pilar, que possui expertise em imóveis Off-Market, e na região e faixa de valor do seu imóvel. \n O corretor entrará em contato com você para realizar uma avaliação da sua propriedade e, em seguida, apresentará seu imóvel a compradores exclusivos e qualificados, sem qualquer exposição pública. Antes de mostrar seu imóvel, a autenticidade e qualificação dos compradores serão rigorosamente verificadas, garantindo que apenas aqueles realmente interessados e com capacidade de compra tenham acesso ao seu imóvel. Isso assegura que a venda seja realizada de forma segura e discreta, preservando tanto o valor quanto a privacidade da sua propriedade.'
			},
			{
				question: 'Qual é o processo de compra de um imóvel Off-Market?',
				answer:
					'Para comprar um imóvel no modelo Off-Market no PilarHomes, o primeiro passo é clicar em "Falar com especialistas" e preencher o formulário com os detalhes sobre o imóvel que está procurando. Com as informações fornecidas, a equipe do PilarHomes conectará você a um corretor de excelência da Rede Pilar, especializado em imóveis Off-Market e no perfil que você busca. \n Com esses dados, o corretor fará uma seleção personalizada e apresentará imóveis exclusivos, perfeitamente alinhados às suas necessidades e preferências, sem qualquer exposição pública. Isso garante que você tenha acesso a oportunidades únicas, que não estão disponíveis no mercado aberto, preservando tanto a natureza exclusiva do imóvel quanto a sua privacidade durante todo o processo.'
			},
			{
				question: 'Como funciona a negociação de imóveis Off-Market?',
				answer:
					'A negociação de imóveis Off-Market ocorre de forma confidencial e direta entre comprador e vendedor, com o acompanhamento do Parceiro Pilar, sem a participação de múltiplos intermediários. Esse modelo garante que todas as conversas e detalhes sejam tratados com sigilo, preservando a privacidade de ambas as partes, e proporciona um processo assertivo e personalizado, ajustando os termos conforme as necessidades e expectativas de cada parte. \n Quando o acordo é fechado, a concretização do negócio ocorre com total sigilo e segurança, assegurando que todas as etapas sejam realizadas de forma discreta e protegida. Isso resulta em uma experiência de compra e venda mais segura, eficiente e confidencial para todos os envolvidos.'
			},
			{
				question: 'Quanto o PilarHomes cobra para vender imóveis Off-Market?',
				answer:
					'O PilarHomes oferece uma solução sem custos extras para o vendedor. Nossa remuneração é paga pelo próprio corretor parceiro, e você, proprietário, fica responsável apenas pela taxa de corretagem com a concretização da venda, de até 6%.'
			}
		],
		CTA: {
			talkToSpecialist: {
				label: 'Falar com um especialista',
				icon: NorthEastIcon
			}
		}
	}
};
